import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Builder } from '@/components/dashboards/builder/Builder';
import { errorText } from '@/lib/errors';
import { requirePermission } from '@/lib/guards';
import { orpc } from '@/lib/orpc';

export const Route = createFileRoute('/_app/dashboards/$dashboardId/edit')({
  beforeLoad: ({ context }) => requirePermission(context.me, 'dashboards.edit'),
  component: EditPage
});

/** Opens the newest version (draft or proposal), not the published one: editing continues where it stopped. */
function EditPage() {
  const { t } = useTranslation();
  const { dashboardId } = Route.useParams();
  const head = useQuery(orpc.dashboards.get.queryOptions({ input: { id: dashboardId } }));
  const latest = head.data?.latestVersion;
  const loaded = useQuery({ ...orpc.dashboards.get.queryOptions({ input: { id: dashboardId, version: latest ?? 1 } }), enabled: latest !== undefined });
  const catalog = useQuery({ ...orpc.dashboards.catalog.queryOptions(), staleTime: 300_000 });
  const schema = useQuery({ ...orpc.dashboards.schema.queryOptions(), staleTime: Infinity });

  const error = head.error ?? loaded.error ?? catalog.error;
  if (error) return <div className="p-6 text-sm">{errorText(t, error)}</div>;
  if (!loaded.data || !catalog.data) return <div className="skeleton m-6 h-96" />;
  if (loaded.data.access === 'viewer') return <div className="p-6 text-sm">{t('errors.FORBIDDEN')}</div>;
  return (
    <div className="px-6 pb-6">
      <Builder key={`${loaded.data.id}:${loaded.data.version}`} loaded={loaded.data} catalog={catalog.data} schema={schema.data} />
    </div>
  );
}
